import React, { useState } from 'react';
import dayjs from 'dayjs';

import DelayDiv from 'modules/common/components/DelayDiv';
import HistogramCard, { useHistogramCard } from '../components/HistogramCard';
import TopOrg from '../components/TopOrg';
import { useLineChart, useTopSubs } from '../hooks';

const lineChartOptions = [
  {
    id: 'transaction',
    hook: useLineChart,
    defaultChart: 'line',
  },
];

function Month() {
  const lineProps = useHistogramCard(lineChartOptions);

  const [filter, setFilter] = useState({
    type: 'MONTHLY',
    date_from: dayjs().startOf('month').format('YYYY-MM-DD 00:00:00'),
    date_to: dayjs().endOf('month').format('YYYY-MM-DD 23:59:59'),
  });

  const [isLoading, data] = useTopSubs(filter);
  return (
    <div className="space-y-8">
      <DelayDiv
        className="px-4 pt-4"
        delay={100}
        loader={
          <div
            className="col-span-2 bg-neutral-100 animate-pulse rounded-lg"
            style={{ height: 361 }}
          />
        }
      >
        <HistogramCard
          {...lineProps}
          withActions
          hasSelectDate
          dateRange={false}
          defaultMode="month"
          setFilter={setFilter}
        />
      </DelayDiv>
      <TopOrg filter={filter} data={data} isLoading={isLoading} />
    </div>
  );
}

export default Month;
